import React from 'react';
import Snackbar from '@mui/material/Snackbar';

import { useSnackbar, useSnackbarProps } from '@lib/useSnackbar';
import type { IAppProps } from '../App.typings';

export function withSnackbar<T extends IAppProps>(Base: React.FC<T>): React.FC<T> {
    return props => {
        const snackbar = useSnackbarProps();
        const { hide } = useSnackbar();

        return (
            <Base {...props}>
                <Snackbar
                    open={snackbar.duration > 0}
                    autoHideDuration={snackbar.duration}
                    message={snackbar.text}
                    anchorOrigin={{
                        horizontal: snackbar.horizontal ?? 'right',
                        vertical: snackbar.vertical ?? 'bottom',
                    }}
                    onClose={hide}
                />
            </Base>
        );
    };
}
